import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { prop } from 'ramda';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';
import { useSetLanguagePathname } from './useSetLanguagePathname';

export const useNormalizeUrl = () => {
    const { pathLang } = useParams<{ pathLang: string }>();
    const userLang = useUserSelector(prop('lang'));
    const defaultLanguage = useAppSelector(prop('defaultLocale'));
    const setLanguagePathname = useSetLanguagePathname({ shouldReload: false });

    useEffect(() => {

        /* Lugano changes - make sure default language will be always present in URL */
        if (!pathLang && userLang) {
            setLanguagePathname(userLang, true, false);
        }

    }, [defaultLanguage, pathLang, userLang, setLanguagePathname]);
};
